function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M391.605 257.983C440.762 257.983 480.604 217.8 480.604 168.209C480.604 118.619 440.812 78.4863 391.605 78.4863C342.398 78.4863 302.557 118.669 302.557 168.26C302.557 217.85 342.398 258.033 391.605 258.033V257.983Z",
  fill: "#FBB416"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M117.242 258.033C147.351 258.033 171.747 233.437 171.747 203.07C171.747 172.702 147.351 148.106 117.242 148.106C87.1334 148.106 62.7382 172.702 62.7382 203.07C62.7382 233.437 87.1334 258.033 117.242 258.033Z",
  fill: "#FBB416"
});

var SvgAginicIconPositive = function SvgAginicIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 338,
    viewBox: "0 0 543 338",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAginicIconPositive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aginic_icon_positive.10c44200.svg";
export { ForwardRef as ReactComponent };